import {
  Button, Card, CardContent, CardHeader, CircularProgress, Dialog, DialogContent, DialogActions, Divider, Grid, IconButton, List, ListItem,
  ListItemAvatar, ListItemSecondaryAction, ListItemText, Tooltip, Typography,
  ExpansionPanelDetails, TableContainer, ExpansionPanelSummary, Paper, Table, TableBody, TableRow, TableCell, Badge, ExpansionPanel
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import axios from 'src/utils/axios';
import { getUser, openBlob } from 'src/utils/Common';
import { loadBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { MdPhonelinkSetup } from 'react-icons/md';
import { VscFilePdf } from 'react-icons/vsc';
import { FaRegFileWord } from 'react-icons/fa';
import { RiFileExcel2Line } from 'react-icons/ri';
import { BiImage } from 'react-icons/bi';
import { GrDocumentZip } from 'react-icons/gr';
import BomListLibrary from 'src/components/BomListLibrary';
import CloseIcon from '@material-ui/icons/Close';
import ListIcon from '@material-ui/icons/List';
import Hizmet from './Defect';
import ErrorMessage from 'src/components/ErrorMessage';

const useStyles = makeStyles((theme) => ({
  root: {},
  contentB: {
    minHeight: 430,
  },
  dividerB: {
    backgroundColor: '#1D3343'
  },
}));


function Bulten({
  className, ReceiptNo, readonly, tasks
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [BultenData, setBultenData] = useState([]);
  const SessionUser = getUser();
  const BirimKodu = SessionUser.ServiceShopId;
  const TeknisyenKodu = SessionUser.TechnicianId;
  const [Loading, setLoading] = useState(true);
  const [BomList, setBomList] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const Data = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
  const Model = Data && Data[0] && Data[0].ModelCode;
  const isOnline = useSelector((state) => state.status?.isOnline);

  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      let ModelParam = '-1';
      if (Model !== '') {
        ModelParam = Model;
      }
      axios.get(`/GetSiriusBulletin/1/${BirimKodu}/${TeknisyenKodu}/${ModelParam}`).then((response) => {
        if (mounted) {
          const Deger = response.data === '' ? [] : response.data;
          setBultenData(Deger);
          setLoading(false);
        }
      }).catch((error) => {
        setLoading(false);
      });
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [ReceiptNo, BirimKodu, TeknisyenKodu, Model]);

  const BultenDetayAc = (log) => {
    setLoading(true);
    const dataBultenDetay = {
      ServiceShopId: SessionUser.ServiceShopId,
      UserId: SessionUser.UserId,
      FilePtr: log.StreamId,
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/FileImportExport/SiriusBulletin', dataBultenDetay, config)
      .then((response) => {
        openBlob(response.data, `${log.BT}_${log.AY}_${log.BN}`);
        setLoading(false);
      }).catch((error) => {

        setLoading(false);
      });
  };

  const getBomList = () => {
    setBomList(true);
  };

  const user = getUser();
  const user_types = user.TechnicianType.split(',');
  let klima_teknisyeni = false;
  user_types && user_types.forEach((u) => {
    if (parseInt(u) === 26) {
      klima_teknisyeni = true;
    }
  });
  if (klima_teknisyeni) {
    return (
      <Card>
        <CardHeader title={t('Yetki_Kontrolu')} />
        <Divider />
        <CardContent className={classes.contentB}>
          {t('Yetki_Kontrolu_Mesaji')}
        </CardContent>
      </Card>
    );
  }

  const renderSwitch = (param) => {
    switch (param) {
      case 'image/bmp': return <BiImage />;
      case 'image/jpeg': return <BiImage />;
      case 'image/gif': return <BiImage />;
      case 'application/pdf': return <VscFilePdf />;
      case 'application/x-zip-compressed': return <GrDocumentZip />;
      case 'application/msword': return <FaRegFileWord />;
      case 'application/vnd.ms-excel': return <RiFileExcel2Line />;
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': return <RiFileExcel2Line />;
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': return <RiFileExcel2Line />;
      case 'application/x-msdownload': return <MdPhonelinkSetup />;
      case 'application/unknown': return <MdPhonelinkSetup />;
      case 'application/octet-stream': return <MdPhonelinkSetup />;
      default: return <MdPhonelinkSetup />;
    }
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      <Card className={clsx(classes.root, className)}>
        <CardHeader title={t('Kutuphane')} />
        <Divider />
        <CardContent className={classes.contentB}>
          {isOnline ? (
            <Fragment>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4} lg={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ alignItems: 'right' }}
                    onClick={() => getBomList()}
                    className={classes.button}
                    endIcon={<ListIcon>send</ListIcon>}
                  >
                    BOM
                  </Button>
                </Grid>
              </Grid>
              <br></br>
              <div className={classes.inner}>
                {Loading
                  ? (
                    <CircularProgress
                      status="loading"
                      style={{ marginLeft: '50%' }}
                    />
                  )
                  : BultenData.map((log) => (
                    <ExpansionPanel key={log.DocumentType} expanded={expanded === log.DocumentTypeId} onChange={handleChange(log.DocumentTypeId)}>
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography className={classes.secondaryHeading}>
                          {log.DocumentType}
                          <IconButton aria-label="cart">
                            <Badge badgeContent={log.Documents.length} color="secondary" />
                          </IconButton>
                        </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        <TableContainer component={Paper}>
                          <Table className={classes.table} aria-label="simple table">
                            <TableBody>
                              {log.Documents.map((row) => (
                                <TableRow
                                  key={row.DocumentId}
                                >
                                  <TableCell
                                    component="th"
                                    onClick={(e) => BultenDetayAc(row)}
                                    scope="row"
                                  >
                                    <IconButton aria-label="cart">
                                      {renderSwitch(row.StreamMimeType)}
                                    </IconButton>
                                    {row.StreamName}
                                  </TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  ))}
              </div>
            </Fragment>
          ) : (
            <ErrorMessage message={t('Offline_Message')} />
          )}
        </CardContent>
        <Dialog
          open={BomList}
          fullWidth
          maxWidth="lg"
          onClose={event => setBomList(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent style={{ overflow: 'hidden' }}>
            <BomListLibrary ReceiptNo={ReceiptNo} readonly={false} />
          </DialogContent>
          <DialogActions>
            <IconButton
              color="primary"
              onClick={event => setBomList(false)}
              aria-label="upload picture"
              component="span"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </Dialog>
      </Card>
    </div>
  );
}

Bulten.propTypes = {
  className: PropTypes.string
};

export default connect(
  (state) => ({ tasks: state.tasks1 })
)(Bulten);
